import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { deleteZoneJson, GetAllZoneData, UpdateOnePosZone, ZoneDetailsAPi, ZoneListApiResponse, zoneListPayload, zonePostPayLoad } from "../../components/settings/zone/zoneModule";
import { ZenToast } from "zen-core-elements";
import { Code } from "../../components/customers/addEditCustomerModule";

interface intialState {
    zoneList: { row: GetAllZoneData[], count: number, isRefresh: boolean }
    stateData: Record<string, Code[]>
}

const intialState: intialState = {
    zoneList: { row: [], count: 0, isRefresh: false },
    stateData: {}
}

export const getAllZone = createAsyncThunk('zone/getAllZone', ({ storeId, data }: { storeId: number, data: zoneListPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.getAllPosZone, { storeId: storeId })
    return HttpRoutingService.getMethod<ZoneListApiResponse>(url, data)
})

export const getOneZoneDetails = createAsyncThunk('zone/getOneZoneDetails', ({ storeId, zoneId }: { storeId: Number, zoneId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getOnePosZoneNames, { storeId: storeId, zoneId: zoneId })
    return HttpRoutingService.getMethod<ZoneDetailsAPi>(url)
})

export const addZone = createAsyncThunk('zone/addZone', ({ storeId, data }: { storeId: number, data: zonePostPayLoad }) => {
    const url = HttpRoutingService.replaceUrl(API.getAllPosZone, { storeId: storeId })
    return HttpRoutingService.postMethod<UpdateOnePosZone>(url, data)
})

export const editZone = createAsyncThunk('zone/getOnePosUpdateZone', ({ storeId, zoneId, data }: { storeId: number, zoneId: number, data: zonePostPayLoad }) => {
    const url = HttpRoutingService.replaceUrl(API.getOnePosZoneNames, { storeId: storeId, zoneId: zoneId })
    return HttpRoutingService.putMethod<UpdateOnePosZone>(url, data)
})

export const deleteOneZone = createAsyncThunk('zone/deleteOneZone', ({ storeId, zoneId }: { storeId: number, zoneId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getOnePosZoneNames, { storeId: storeId, zoneId: zoneId })
    return HttpRoutingService.deleteMethod<deleteZoneJson>(url)
})

export const zoneSlice = createSlice({
    name: 'zone',
    initialState: intialState,
    reducers: {
        setZoneListRefresh(state) {
            state.zoneList.isRefresh = !state.zoneList.isRefresh
        },
        setStateData(state, action: PayloadAction<{ countryCode: string, data: Code[] }>) {
            state.stateData[action?.payload?.countryCode] = action?.payload?.data
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getAllZone.fulfilled, (state, action) => {
                let { zones } = action.payload
                let { data: { offset } } = action?.meta?.arg
                if (offset > 0) {
                    if (zones?.rows?.length) {
                        state.zoneList.row = [...state.zoneList.row, ...zones?.rows]
                    }
                } else {
                    state.zoneList.row = zones?.rows || []
                }
                state.zoneList.count = zones?.count || 0
            })
            .addCase(getAllZone.rejected, () => {
                ZenToast({ type: "error", message: "Failed to get a zone list" })
            })
    },
})

export const { setStateData, setZoneListRefresh } = zoneSlice?.actions

export default zoneSlice.reducer





